const PATH = "/api/v1/discover";

const ENDPOINTS = {
  ZO_DISCOVER_HOME: "/home/",
  ZO_DISCOVER_PLAYLISTS: "/playlist/",
  ZO_DISCOVER_OPERATORS: "/operators/",
  ZO_DISCOVER_HERO_BANNER: "/hero-banner/",
};

export type ZODiscoverEndpoints = keyof typeof ENDPOINTS;
export const ZODiscoverCollection = { PATH, ENDPOINTS };
